import styled from "@emotion/styled";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FONT_FAMILY_PRIMARY } from "shared/theme";
import {
  COLOR_BLACK,
  COLOR_GREY100,
  COLOR_GREY_2,
  COLOR_GREY_3,
  COLOR_GREY_8,
  COLOR_WHITE,
} from "shared/theme/colors";

export const StyledNativeSelect = styled(Select, {
  shouldForwardProp: (props) => props !== "filled",
})<{ filled?: number }>`
  &.MuiInputBase-root {
    background: none !important;
    height: 40px !important;
    cursor: pointer;
  }

  .MuiSelect-select {
    font-size: 14px;
    padding: 0 2rem 0 1rem;
    font-family: ${FONT_FAMILY_PRIMARY};
    border-radius: 0.5rem;
    height: 40px !important;
    color: ${({ filled }) => (filled ? COLOR_BLACK : COLOR_GREY_8)};
    background-color: ${COLOR_WHITE};
    border: 1px solid ${COLOR_GREY100};
    display: flex;
    align-items: center !important;

    &:focus {
      background-color: none;
    }

    &.Mui-disabled {
      background-color: ${COLOR_GREY_2};
    }
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  font-family: ${FONT_FAMILY_PRIMARY};
  font-size: 14px;
  color: ${COLOR_BLACK};
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid ${COLOR_GREY_3};

  &:last-child {
    border-bottom: none;
  }

  &.Mui-selected {
    background-color: ${COLOR_GREY_2};
  }

  &.Mui-selected:hover {
    background-color: ${COLOR_GREY_3};
  }

  &:hover {
    background-color: ${COLOR_GREY_3};
  }

  &.Mui-disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
